// src/ui/FileUpload.jsx
import React, { useRef, useState } from "react";
import clsx from "clsx";

export default function FileUpload({
  onFilesSelected,
  multiple = true,
  label = "Upload files",
  accept,
  className,
}) {
  const inputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);

  const handleFiles = (files) => {
    if (!files || files.length === 0) return;
    onFilesSelected?.(Array.from(files));
  };

  return (
    <div
      className={clsx(
        "rounded-2xl border border-dashed border-[var(--mudo-border)]",
        "bg-[var(--mudo-bg-soft)]/70 backdrop-blur-md px-4 py-6",
        "flex flex-col items-center justify-center gap-2 text-center",
        "transition-colors duration-150",
        dragOver && "border-[var(--mudo-primary)] bg-[var(--mudo-bg-soft)]/90",
        className
      )}
      onDragOver={(e) => {
        e.preventDefault();
        setDragOver(true);
      }}
      onDragLeave={(e) => {
        e.preventDefault();
        setDragOver(false);
      }}
      onDrop={(e) => {
        e.preventDefault();
        setDragOver(false);
        handleFiles(e.dataTransfer.files);
      }}
      onClick={() => inputRef.current?.click()}
    >
      <div className="text-sm font-medium text-[var(--mudo-text)]">{label}</div>
      <div className="text-xs text-[var(--mudo-text-muted)]">Drag & drop or click to choose</div>

      <input
        ref={inputRef}
        type="file"
        className="hidden"
        multiple={multiple}
        accept={accept}
        onChange={(e) => handleFiles(e.target.files)}
      />
    </div>
  );
}
